var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6627 3.84375H2.90881C2.48857 3.84375 2.14905 4.17891 2.14905 4.59375V19.5938C2.14905 20.0086 2.48857 20.3438 2.90881 20.3438H22.6627C23.083 20.3438 23.4225 20.0086 23.4225 19.5938V4.59375C23.4225 4.17891 23.083 3.84375 22.6627 3.84375ZM21.713 18.6562H3.85852V5.53125H21.713V18.6562ZM6.06896 16.7273C6.14257 16.8 6.26365 16.8 6.33726 16.7273L10.4329 12.6844L13.149 15.368C13.2226 15.4406 13.3437 15.4406 13.4173 15.368L20.4689 8.40234C20.5425 8.32969 20.5425 8.21016 20.4689 8.1375L19.5952 7.275C19.5595 7.24011 19.5113 7.22053 19.461 7.22053C19.4108 7.22053 19.3626 7.24011 19.3269 7.275L13.2844 13.2422L10.5682 10.5586C10.5325 10.5237 10.4843 10.5041 10.4341 10.5041C10.3838 10.5041 10.3356 10.5237 10.2999 10.5586L5.19761 15.5977C5.16226 15.6329 5.14243 15.6805 5.14243 15.7301C5.14243 15.7797 5.16226 15.8273 5.19761 15.8625L6.06896 16.7273Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund);
export default __webpack_public_path__ + "static/media/fund.a68412f49a3d15afa1101aaf2b964471.svg";
export { ForwardRef as ReactComponent };